module.exports = __webpack_public_path__ + "B_right.18e73126.png";